import { render, staticRenderFns } from "./ReadMoreComponent.vue?vue&type=template&id=396378ea"
import script from "./ReadMoreComponent.vue?vue&type=script&lang=js"
export * from "./ReadMoreComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports